import React, { useEffect } from 'react';
import { Card, Col, Form, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import {
  CATEGORY_ITEMS,
  GUTTER,
  LABEL,
  NOT_AVAILABLE_MESSAGE,
} from '@moxie/constants';

const EmergencyContactDetailsTab: React.FC<any> = (props) => {
  const { contactDetails } = props;
  const [form] = useForm();

  useEffect(() => {
    if (contactDetails.length > 0) {
      form.setFieldsValue({ emergencyContactDetails: contactDetails });
    } else {
      form.resetFields();
    }
  }, [contactDetails, form]);

  return (
    <Card title={CATEGORY_ITEMS[3].name}>
      <Form
        initialValues={{
          emergencyContactDetails: [{}],
        }}
        form={form}
        scrollToFirstError={true}
        labelCol={{ lg: 7, md: 8, xl: 10, span: 10 }}
        wrapperCol={{ span: 14, offset: 1 }}
      >
        <Form.List name="emergencyContactDetails">
          {(fields) => {
            return (
              <>
                {fields.map(({ key, name }) => {
                  return (
                    <Card key={key} className="margin-bottom-1">
                      <Row gutter={GUTTER}>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <Form.Item
                            className="custom_label_style initial_capital"
                            name={[name, 'contact_name']}
                            label={LABEL.NAME}
                            rules={[{ required: true }]}
                          >
                            {contactDetails[name]?.contact_name
                              ? contactDetails[name]?.contact_name
                              : NOT_AVAILABLE_MESSAGE}
                          </Form.Item>
                        </Col>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <Form.Item
                            className="custom_label_style initial_capital"
                            name={[name, 'relationship']}
                            label={LABEL.RELATIONSHIP}
                            rules={[{ required: true }]}
                          >
                            {contactDetails[name]?.relationship
                              ? contactDetails[name]?.relationship
                              : NOT_AVAILABLE_MESSAGE}
                          </Form.Item>
                        </Col>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <Form.Item
                            className="custom_label_style"
                            name={[name, 'email']}
                            label={LABEL.EMAIL}
                          >
                            {contactDetails[name]?.email
                              ? contactDetails[name]?.email.toLowerCase()
                              : NOT_AVAILABLE_MESSAGE}
                          </Form.Item>
                        </Col>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <Form.Item
                            className="custom_label_style"
                            name={[name, 'phone']}
                            label={LABEL.PHONE_NUMBER}
                            rules={[{ required: true }]}
                          >
                            {contactDetails[name]?.phone
                              ? contactDetails[name]?.phone
                              : NOT_AVAILABLE_MESSAGE}
                          </Form.Item>
                        </Col>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <div id="country_list" className="relative">
                            <Form.Item
                              className="custom_label_style"
                              name={[name, 'address', 'country']}
                              label={LABEL.COUNTRY}
                              rules={[{ required: true }]}
                            >
                              {contactDetails[name]?.address?.country
                                ? contactDetails[name]?.address?.country
                                : NOT_AVAILABLE_MESSAGE}
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <Form.Item
                            className="custom_label_style initial_capital"
                            name={[name, 'address', 'state']}
                            label={LABEL.STATE}
                          >
                            {contactDetails[name]?.address?.state
                              ? contactDetails[name]?.address?.state
                              : NOT_AVAILABLE_MESSAGE}
                          </Form.Item>
                        </Col>
                        <Col span={24} md={24} lg={24} xl={12} xxl={8}>
                          <Form.Item
                            className="custom_label_style initial_capital"
                            name={[name, 'address', 'city']}
                            label={LABEL.CITY}
                          >
                            {contactDetails[name]?.address?.city
                              ? contactDetails[name]?.address?.city
                              : NOT_AVAILABLE_MESSAGE}
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  );
                })}
              </>
            );
          }}
        </Form.List>
      </Form>
    </Card>
  );
};

export { EmergencyContactDetailsTab };
